{
  "luggage": {
    "unit_KG": "kg",
    "unit_PC": "pc"
  }
}
